export default "__VITE_ASSET__CODl3hEi__"